import { STORE_TYPES } from '../../config/tenantTypes';
import { jewelleryMenu } from './menu';
import { jewelleryRoutes } from './routes';

const JewelleryModule = {
  key: STORE_TYPES.JEWELLERY,
  defaultPath: '/dashboard',
  menu: jewelleryMenu,
  routes: jewelleryRoutes,
};

export default JewelleryModule;
